import { useState } from "react";
import { Plus, Pencil, Archive } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { PageHeader, Badge, useConfirm } from "@/components/opl/Common";
import { useList, FormDialog, DataTable, GoldBtn, IconBtn } from "@/components/opl/Crud";

const FIELDS = [
  { name: "name", label: "Club name", required: true }, { name: "branch", label: "Branch" },
  { name: "city", label: "City" }, { name: "contact_name", label: "Contact person" }, { name: "active", label: "Active", type: "switch" },
];

export default function Clubs() {
  const [rows, load] = useList("/clubs");
  const [edit, setEdit] = useState(null);
  const [dialog, confirm] = useConfirm();
  const save = async (v) => {
    if (v.id) await api.put(`/clubs/${v.id}`, v); else await api.post("/clubs", v);
    toast.success("Club saved");
    load();
  };
  return (
    <div>
      {dialog}
      <PageHeader title="Clubs & Branches" crumbs={["Clubs"]}><GoldBtn testid="add-club-btn" onClick={() => setEdit({ active: true })}><Plus className="h-4 w-4" />Add club</GoldBtn></PageHeader>
      <DataTable rows={rows} testid="clubs-table" columns={[
        { key: "name", label: "Club", render: (r) => <b>{r.name}</b> }, { key: "branch", label: "Branch" }, { key: "city", label: "City" },
        { key: "contact_name", label: "Contact" },
        { key: "active", label: "Status", render: (r) => <Badge className={r.active ? "text-emerald-300 border-emerald-500/40" : "text-slate-400"}>{r.active ? "Active" : "Inactive"}</Badge> },
        { key: "a", label: "", render: (r) => <div className="flex justify-end"><IconBtn testid={`edit-club-${r.id}`} onClick={() => setEdit(r)}><Pencil className="h-4 w-4" /></IconBtn>
          <IconBtn testid={`archive-club-${r.id}`} onClick={() => confirm({ title: `Archive ${r.name}?`, destructive: true, confirmLabel: "Archive", onConfirm: async () => { try { await api.delete(`/clubs/${r.id}`); toast.success("Archived"); load(); } catch (e) { toast.error(e.response?.data?.detail); } } })}><Archive className="h-4 w-4" /></IconBtn></div> },
      ]} />
      <FormDialog open={!!edit} onOpenChange={(o) => !o && setEdit(null)} title={edit?.id ? "Edit club" : "Add club"} fields={FIELDS} initial={edit} onSubmit={save} />
    </div>
  );
}
